import type { MailIntegrationRepository } from "../../../domain/repositories/company/mail-integration-repository";
import { mailIntegrationApiService } from "../../api/company/mail-integration-api-service";
import type {
  MailIntegrationSetting,
  SaveMailIntegrationRequest,
} from "../../../domain/types/mail-integration";

export class MailIntegrationRepositoryImpl
  implements MailIntegrationRepository
{
  async getSetting(
    companyId: number,
  ): Promise<MailIntegrationSetting | null> {
    const response = await mailIntegrationApiService.getSetting(companyId);
    return response.data ?? null;
  }

  async saveSetting(
    companyId: number,
    request: SaveMailIntegrationRequest,
  ): Promise<MailIntegrationSetting> {
    const response = await mailIntegrationApiService.saveSetting(
      companyId,
      request,
    );

    if (!response.data) {
      throw new Error(
        response.errorMsg || "메일 연동 설정 저장에 실패했습니다.",
      );
    }

    return response.data;
  }
}
